var _effectorFileName = "/builds/gmini/front-ui-kit/src/DialogTitle/DialogTitle.tsx";
import { Typography } from '../Typography';
import { DialogTitleWrapper } from './DialogTitle.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogTitle = ({
  children,
  disableTypography = false,
  ...props
}) => /*#__PURE__*/_jsx(DialogTitleWrapper, { ...props,
  children: disableTypography ? children : /*#__PURE__*/_jsx(Typography, {
    variant: "h6",
    children: children
  })
});